import { percentageLevels } from "utils/indicator/indicatorSettings";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";
import styles from "./MunicipalitySchoolsAttendanceRow.module.styl";
import Chart from "react-apexcharts";
import { exact, number, string } from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

export default function MunicipalitySchoolsAttendanceRow({ municipalityId, schoolAttendance }) {
    const indicatorStyle = percentageLevels.indicatorColor(schoolAttendance.attendancePercent);
    const options = chartOptions(indicatorStyle);
    const series = [schoolAttendance.attendancePercent];

    return (
        <div className={styles.row}>
            <Link
                to={`/attendance/municipality/${municipalityId}/school/${schoolAttendance.schoolId}`}
                className={styles.schoolName}
            >
                {schoolAttendance.schoolName}
            </Link>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

MunicipalitySchoolsAttendanceRow.propTypes = {
    municipalityId: number.isRequired,
    schoolAttendance: exact({
        schoolId: number.isRequired,
        schoolName: string.isRequired,
        attendancePercent: number.isRequired,
    }),
};
